import { createContext, useContext } from 'react';

/** The saved report a turn's result belongs to: the one it re-ran, or the one it was just saved as. */
export interface TurnSavedReport {
    id: string;
    name: string;
}

export interface ReportTurnContextValue {
    savedReport: TurnSavedReport | null;
    setSavedReport: (savedReport: TurnSavedReport) => void;
    /**
     * The saved report this conversation is editing: the one it was opened
     * from, or the last one saved in it. Saving a changed report updates it
     * in place unless the person asks for a new one.
     */
    editingReport: TurnSavedReport | null;
}

export const ReportTurnContext = createContext<ReportTurnContextValue>({
    savedReport: null,
    setSavedReport: () => undefined,
    editingReport: null,
});

export const useReportTurn = (): ReportTurnContextValue => useContext(ReportTurnContext);

/** The in-app path that re-runs a saved report. */
export const savedReportRunPath = (savedReport: TurnSavedReport): string =>
    `/reports?run=${encodeURIComponent(savedReport.id)}&name=${encodeURIComponent(savedReport.name)}`;
